<template>
  <div class="price-information col mt-lg-0">
    <div class="mb-5">
      <step-title
        title="Precificação"
        description="Informe como você deseja monetizar o seu curso online."
      />
    </div>

    <!-- <action-dispatcher action="product/getCurrency">
      <bp-select
        class="mt-6"
        v-model="form.currency"
        id="currency"
        label="Moeda base"
        placeholder="Selecione a moeda..."
        select
        :options="[{ id: 'BRL', name: 'Real Brasileiro' }]"
        :errors="errors.currency"
        required
        size="xl"
        description="Em caso de venda para outros países, usaremos esta moeda como base para a conversão."
      />
    </action-dispatcher> -->

    <bp-input
      v-model="form.price"
      money
      :moneyConfig="moneyConfig"
      class="my-5"
      id="price"
      preIcon="fa-light fa-brazilian-real-sign"
      label="Valor em Real Brasileiro (R$)"
      placeholder="Informe o preço"
      :errors="errors.price"
      required
      description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que R$ 4,00."
      :min="4"
    />
    <bp-input
      :disabled="isParceledBillet"
      v-model="form.price_usd"
      money
      :moneyConfig="{ ...moneyConfig, currency: '$' }"
      class="my-5"
      id="price"
      preIcon="fa-light fa-dollar"
      label="Valor em Dólar Americano (US$)"
      placeholder="Informe o preço"
      :errors="errors.price_usd"
      description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que US$ 4,00."
      :min="4"
    />
    <bp-input
      :disabled="isParceledBillet"
      v-model="form.price_eur"
      money
      :moneyConfig="{ ...moneyConfig, currency: '€' }"
      class="my-5"
      id="price"
      preIcon="fa-light fa-euro"
      label="Valor em Euro (€)"
      placeholder="Informe o preço"
      :errors="errors.price_eur"
      description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que € 4,00."
      :min="4"
    />

    <payment-methods
      v-model="form.payment_methods_ids"
      :showForeignInfo="showForeignInfo"
    />

    <template v-if="isParceledBillet">
      <bp-select
        v-model="form.billet_installments"
        class="my-5"
        label="Parcelamento"
        description="Defina o número máximo de parcelas no boleto."
        :options="billetInstallmentOptions"
      />

      <bp-switch
        v-model="form.billet_apply_interest"
        label="Taxa sobre parcelamento de boletos"
      />
      <div class="functional-2 text-neutral-400">
        Em uma compra parcelada por boletos, serão aplicados juros sobre as
        parcelas.
      </div>
    </template>

    <template v-else-if="isCardSale">
      <bp-select
        v-model="form.installments"
        class="my-5"
        label="Parcelamento"
        description="Defina o número máximo de parcelas. ATENÇÃO: Parcelamento válido somente para compras em cartão."
        :options="installmentOptions"
        :disabled="disableInstallments"
      />

      <div class="d-flex align-items-center mt-5">
        <b-form-checkbox
          switch
          class="mr-5 text-switch"
          id="product-status"
          v-model="form.is_tax_to_producer"
        >
          Taxas para o produtor
        </b-form-checkbox>
      </div>
      <span class="small-text text-secondary">
        Em uma compra parcelada, o produtor pagará as taxas do parcelamento
      </span>

      <div class="d-flex align-items-center mt-5">
        <b-form-checkbox
          switch
          class="mr-5 text-switch"
          id="smart-installment"
          v-model="form.smart_installment"
        >
          Recuperar automaticamente vendas de cartões com limite insuficiente.
        </b-form-checkbox>
      </div>
      <span class="small-text text-secondary">
        Em uma compra parcelada, se o cartão é negado por saldo insuficiente,
        cobramos as parcelas em formato de recorrência para tentar evitar que
        você perca a venda.
      </span>
    </template>

    <bp-select
      v-model="form.warranty"
      select
      required
      class="mt-5"
      id="warranty"
      label="Garantia do produto"
      placeholder="Selecionar..."
      :options="warranties"
      :errors="errors.warranty"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import PaymentMethods from "./PaymentMethods.vue";
export default {
  components: {
    PaymentMethods
  },
  props: {
    form: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    isSignature: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    actualStep: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingInstallments: false,
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "",
        masked: false
      }
    };
  },
  computed: {
    ...mapState("product", ["currencies", "warranties"]),
    ...mapState("sale", ["installments"]),
    isParceledBillet() {
      return !!this.form.payment_methods_ids.find(p => p == "parceled_billet");
    },
    billetInstallmentOptions() {
      return Array(18)
        .fill()
        .map((_, i) => ({
          id: i + 1,
          name: `Até ${i + 1} parcela${i ? "s" : ""}`
        }));
    },
    isCardSale() {
      return !!this.form.payment_methods_ids.find(p => [1, 3, 34].includes(p));
    },
    installmentOptions() {
      const opts = [];
      for (let id in this.installments) {
        opts.push({
          id: parseInt(id),
          name: `Até ${id} parcelas de R$ ${this.installments[id]}`
        });
      }
      return opts;
    },

    allowInstallments() {
      return !!this.form.payment_methods_ids.filter(p =>
        ["parceled_billet", 1, 3, 34].includes(p)
      ).length;
    },
    disableInstallments() {
      return !!(
        this.loadingInstallments ||
        !this.form.price ||
        this.form.price < 4 ||
        !this.allowInstallments
      );
    },
    showForeignInfo() {
      return !!this.form.price_usd || !!this.form.price_eur;
    }
  },
  methods: {
    getInstallments(v) {
      if (v < 4 || this.isParceledBillet) return;

      this.loadingInstallments = true;
      this.$store
        .dispatch("sale/getInstallments", {
          installments: 18,
          value: v
        })
        .finally(() => {
          this.loadingInstallments = false;
        });
    }
  },
  watch: {
    "form.price"(v) {
      this.getInstallments(v);
    },
    isParceledBillet(v) {
      if (v) {
        this.form.price_usd = 0;
        this.form.price_eur = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.price-information {
  .text-switch {
    font-size: 14px;
  }
}
</style>
